import {
    SEGMENT_COLORS,
    SEGMENT_STROKE_COLOR,
} from 'common/components/maps/constants';
import {
    POLYGON_MAP,
    POLYGON_OBSTACLE,
    POLYGON_RECTANGLE,
    POLYGON_SEGMENT,
    POLYGON_CIRCLE,
} from 'common/components/segment/constants';

// =============================================================================
// MODOS DE TERRA DRAW
// =============================================================================

export const TERRA_DRAW_MODES = {
    POLYGON: 'polygon',
    RECTANGLE: 'rectangle',
    ANGLED_RECTANGLE: 'angled-rectangle',
    SELECT: 'select',
    CIRCLE: 'circle',
};

export const DRAWING_TYPE_TO_TERRA_DRAW_MODE = {
    [POLYGON_MAP]: TERRA_DRAW_MODES.RECTANGLE,
    [POLYGON_OBSTACLE]: TERRA_DRAW_MODES.POLYGON,
    [POLYGON_SEGMENT]: TERRA_DRAW_MODES.POLYGON,
    [POLYGON_RECTANGLE]: TERRA_DRAW_MODES.ANGLED_RECTANGLE,
    [POLYGON_CIRCLE]: TERRA_DRAW_MODES.CIRCLE,
};

export const getTerraDrawMode = (drawingType) => {
    return DRAWING_TYPE_TO_TERRA_DRAW_MODE[drawingType] || null;
};

// =============================================================================
// ESTILOS
// =============================================================================

export const TERRA_DRAW_STYLES = {
    polygon: {
        fillColor: '#5adec1ff', //SEGMENT_COLORS[2].color,
        fillOpacity: 0.3,
        strokeColor: SEGMENT_STROKE_COLOR,
        strokeWidth: 5,
        closingPointColor: SEGMENT_COLORS[3].color,
        outlineColor: '#4df5ecff',
        outlineWidth: 2,
    },
    rectangle: {
        fillColor: '#5adec1ff', //SEGMENT_COLORS[2].color,
        fillOpacity: 0.3,
        strokeColor: SEGMENT_STROKE_COLOR,
        strokeWidth: 5,
        outlineColor: '#6de9ceff',
        outlineWidth: 2,
    },
    circle: {
        fillColor: '#5adec1ff', //SEGMENT_COLORS[2].color,
        fillOpacity: 0.3,
        strokeColor: SEGMENT_STROKE_COLOR,
        strokeWidth: 5,
        outlineColor: '#6de9ceff',
        outlineWidth: 2,
    },
};

// =============================================================================
// CONFIGURACIÓN
// =============================================================================

export const TERRA_DRAW_CONFIG = {
    polygon: {
        pointerDistance: 20,
        allowSelfIntersections: false,
        minPoints: 3,
    },
    rectangle: {
        pointerDistance: 20,
    },
    circle: {
        pointerDistance: 20,
    },
};

// =============================================================================
// FUNCIONES DE CONVERSIÓN DE COORDENADAS
// =============================================================================

export const convertGeoJSONToPolygon = (geometry) => {
    if (!geometry?.coordinates) return [];

    // GeoJSON usa [lng, lat], necesitamos [lat, lng]
    const coords = geometry.coordinates[0];
    if (!Array.isArray(coords)) return [];

    const polygon = coords.map(([lng, lat]) => [lat, lng]);

    // Remover el último punto si es igual al primero (cierre del polígono GeoJSON)
    if (polygon.length > 1 && isPointEqual(polygon[0], polygon.at(-1))) {
        polygon.pop();
    }

    return polygon;
};

export const convertPolygonToGeoJSON = (polygon) => {
    if (!Array.isArray(polygon) || polygon.length === 0) {
        return { type: 'Polygon', coordinates: [[]] };
    }

    // Convertir [lat, lng] a [lng, lat]
    const coords = polygon.map(([lat, lng]) => [lng, lat]);

    // GeoJSON requiere que el primer y último punto sean iguales
    if (coords.length > 0 && !isPointEqual(coords[0], coords.at(-1))) {
        coords.push([...coords[0]]);
    }

    return { type: 'Polygon', coordinates: [coords] };
};

// =============================================================================
// UTILIDADES INTERNAS
// =============================================================================

const isPointEqual = (point1, point2) => {
    if (!point1 || !point2) return false;
    return point1[0] === point2[0] && point1[1] === point2[1];
};

export const isValidGeometry = (geometry) => {
    if (!geometry?.coordinates || !Array.isArray(geometry.coordinates)) {
        return false;
    }

    const coords = geometry.coordinates[0];
    return Array.isArray(coords) && coords.length >= 3;
};

export const isValidPolygon = (polygon, minPoints = 3) => {
    return Array.isArray(polygon) && polygon.length >= minPoints;
};
